import ProtectedLayout from "./ProtectedLayout";
import ProtectedRoute from "../Routes/ProtectedRoute";

const ProtectedPageLayout = ({ children, ...layoutProps }) => {
  return (
    <ProtectedRoute>
      <ProtectedLayout {...layoutProps}>{children}</ProtectedLayout>
    </ProtectedRoute>
  );
};

export default ProtectedPageLayout;
